<template>
    <div>
        <vs-popup
            class="reprint-modal"
            title="Opnieuw afdrukken" 
            :active.sync="showPopup"
        >
        </vs-popup>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                showPopup: false,
                massActive: false
            };
        },
        mounted() {
            this.isMounted = true;
            this.$events.listen("open-reprint-modal", () => {
                this.showPopup = true;
            });
        },
    }
</script>